interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  label?: string;
};

export function Checkbox(props: CheckboxProps) {
  return (
    <label className={`flex items-center ${props.className}`}>
      <input
        onChange={(e) => props.onChange(e.target.checked)}
        checked={props.checked}
        type="checkbox"
      />
      {props.label && <span className="ml-2 text-sm">{props.label}</span>}
    </label>
  );
}